export default "__VITE_ASSET__DAxZNTh9__"